import styled from 'styled-components';

export const IconWrapper = styled.div`
  display: flex;
  column-gap: 0.25rem;
  cursor: pointer;

  & svg {
    margin-top: 0.2rem;
    width: 1.1rem;
    height: 1.1rem;
  }
`;

export const Link = styled.a`
  font-family: ${({ theme }) => theme.fonts.workSans};
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  text-decoration-line: underline;
  color: ${(p) => p.theme.colors.blue6};
`;
